// extracted by mini-css-extract-plugin
module.exports = {"screenLg":"992px","screenXl":"1200px","screenMd":"768px","screenXlMax":"1199px","screenLgMax":"991px","screenMdMax":"767px","screenSmMax":"575px"};